export function decodedParams(encodedFilterParams: string): any {
  try {
    return JSON.parse(window.atob(encodedFilterParams));
  } catch {
    return {};
  }
}
